import { hash } from 'immutable';
import { combineActions, handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';
import { coreActions } from '../core-actions';

import * as actions from './tagsActions';
import type { TagProps } from './tagsTypes';

export const QcsSyncTagsStoreFactory = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<TagProps>({
  resourceName: 'TAGS',
});

const reducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<TagProps>,
  | coreActions.SanitizeAction
  | ReturnType<typeof actions.createTag>
  | ReturnType<typeof actions.createTagSuccess>
  | ReturnType<typeof actions.createTag>
  | ReturnType<typeof actions.updateTag>
  | ReturnType<typeof actions.updateTagSuccess>
  | ReturnType<typeof actions.deleteTag>
  | ReturnType<typeof actions.deleteTagSuccess>
  | ReturnType<typeof actions.batchTags>
  | ReturnType<typeof actions.batchTagsSuccess>
  | ReturnType<typeof actions.getTags>
  | ReturnType<typeof actions.getTagsSuccess>
  | ReturnType<typeof actions.getTagsFailure>
>(
  {
    [coreActions.SANITIZE]: (state) =>
      state.set(
        'resourcesById',
        state.resourcesById.map((resource) =>
          resource.merge({
            name: hash(resource.name).toString(),
          }),
        ),
      ),

    [actions.createTag.type]: (state, { payload: tag }) => resourceUpserters.upsertResource(state, tag),
    [actions.createTagSuccess.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.deleteTag),

    [actions.updateTag.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateTag),
    [actions.updateTagSuccess.type]: (state, { payload: tag }) => resourceUpserters.upsertResource(state, tag),

    [actions.deleteTag.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createTag),
    [actions.deleteTagSuccess.type]: (state, { payload: tag }) => resourceUpserters.upsertResource(state, tag),

    [actions.batchTags.type]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchTags, false),
    [actions.batchTagsSuccess.type]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchTags, true),

    [actions.getTags.type]: (state) => state.set('isLoading', true),
    [actions.getTagsSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),
    [actions.getTagsFailure.type]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

    [combineActions(
      actions.createTagFailure,
      actions.updateTagFailure,
      actions.deleteTagFailure,
      actions.batchTagsFailure,
    ).toString()]: (state: any, { payload: error }: any) => {
      return resourceUpserters.resetResources(state, error);
    },
  },
  QcsSyncTagsStoreFactory(),
);

export default reducer;
